import { FC } from 'react';

type MapPinIconProps = {
  width?: number;
  height?: number;
  stroke?: string;
} & React.SVGProps<SVGSVGElement>;

export const MapPinIcon: FC<MapPinIconProps> = ({ width = 24, height = 24, stroke = '#394B6F', ...rest }) => (
  <svg width={width} height={height} {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.5 10.5C15.5 12.433 13.933 14 12 14C10.067 14 8.5 12.433 8.5 10.5C8.5 8.567 10.067 7 12 7C13.933 7 15.5 8.567 15.5 10.5Z" stroke={stroke} strokeWidth="1.7" strokeLinejoin="round"/>
    <path d="M12 2C7.30558 2 3.5 5.61786 3.5 10.0807C3.5 14.9412 8.21916 17.3692 11.1092 20.806C11.5669 21.3502 12.4531 21.3646 12.9211 20.8292C15.8645 17.4614 20.5 14.8475 20.5 10.0807C20.5 5.61786 16.6944 2 12 2Z" stroke={stroke} strokeWidth="1.7" strokeLinejoin="round"/>
  </svg>
);
